import { Skeleton } from '@mui/material';
import ArrowRight from '../svgs/ArrowRight';
import { BankComponent } from './BankComponent';

const BankSkeleton = () => {
	return (
		<BankComponent
			logo={<Skeleton variant="circular" />}
			title={<Skeleton variant="text" />}
			icon={<ArrowRight style={{ opacity: 0.2 }} />}
			isSkeleton={true}
			onBankComponentClick={() => {}}
		/>
	);
};

interface BanksLoadingSkeletonProps {
	count: number;
}

export const BanksLoadingSkeleton = ({ count = 3 }: BanksLoadingSkeletonProps) => {
	return (
		<div className="bank-loading-skeletons" style={{ width: '100%' }}>
			{Array.from({ length: count }, (_, i) => i).map((e) => {
				return <BankSkeleton key={`skeleton-${e}`} />;
			})}
		</div>
	);
};
